var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      staticClass: "verify-box",
      staticStyle: { width: "400px" }
    },
    [
      _vm.resData
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "理赔申请",
                visible: true,
                "before-close": _vm.onCloseDialog,
                width: "380"
              }
            },
            [
              _c(
                "el-form",
                { staticStyle: { "margin-left": "10%" } },
                [
                  _c("el-form-item", { attrs: { label: "工单数量：" } }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.resData.count) + "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "商品件数：" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.resData.no_back_num) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "退款金额：" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.resData.refund_goods_money) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "理赔类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-right": "8px" },
                          attrs: { placeholder: "请选择", size: "mini" },
                          on: { change: _vm.setType },
                          model: {
                            value: _vm.form.f_type,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "f_type", $$v)
                            },
                            expression: "form.f_type"
                          }
                        },
                        _vm._l(
                          _vm.resData.type.filter(function(t) {
                            return t.parent_id == 0
                          }),
                          function(item) {
                            return _c("el-option", {
                              key: item.claims_type_id,
                              attrs: {
                                label: item.title,
                                value: item.claims_type_id
                              }
                            })
                          }
                        ),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", size: "mini" },
                          model: {
                            value: _vm.form.type,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "type", $$v)
                            },
                            expression: "form.type"
                          }
                        },
                        _vm._l(_vm.types, function(item) {
                          return _c("el-option", {
                            key: item.claims_type_id,
                            attrs: {
                              label: item.title,
                              value: item.claims_type_id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "计费方式：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { "margin-right": "8px" },
                          attrs: { placeholder: "请选择", size: "mini" },
                          on: {
                            change: function($event) {
                              return _vm.getMoney()
                            }
                          },
                          model: {
                            value: _vm.form.billing_method,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "billing_method", $$v)
                            },
                            expression: "form.billing_method"
                          }
                        },
                        _vm._l(_vm.billing_mehtods, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "输入比例", size: "mini" },
                        on: {
                          blur: function($event) {
                            return _vm.getMoney()
                          }
                        },
                        model: {
                          value: _vm.form.billing_rate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "billing_rate", $$v)
                          },
                          expression: "form.billing_rate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "理赔运费：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "450px" },
                        attrs: { placeholder: "输入理赔运费", size: "mini" },
                        model: {
                          value: _vm.form.shipping_fee,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shipping_fee", $$v)
                          },
                          expression: "form.shipping_fee"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "理赔金额：" } }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.billing_money) + "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "理赔月份：" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          format: "yyyy-MM",
                          type: "month",
                          placeholder: "选择月"
                        },
                        model: {
                          value: _vm.form.shipping_month,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shipping_month", $$v)
                          },
                          expression: "form.shipping_month"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "提交说明：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "textarea",
                          placeholder: "输入提交说明",
                          size: "mini"
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", { on: { click: _vm.onCloseDialog } }, [
                        _vm._v("取 消")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.submitData }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-248b091c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-248b091c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims/components/Claims.vue
// module id = null
// module chunks = 